import React from 'react';
import { FieldType } from 'types/FieldTypes';
import FormModal from 'components/modals/FormModal';

// Rename the name of the function:
const EBoekhoudenIntegrationForm: React.FC<{ viewKey?: string }> = ({ viewKey }) => {

    // Set the api object
    const apiObject = 'integration/eboekhouden';

    // Configure the job fields
    const fields: FieldType[] = [
        {
            type: 'header',
            header: "integrations.general.api_token_label",
            description: "integrations.general.eboekhouden.api_token_description"
        },
        {
            type: 'secret',
            name: 'access_token',
            placeholder: 'integrations.general.api_token_placeholder',
        },
        {
            type: 'header',
            header: "integrations.general.functions_header"
        },
        {
            name: 'import_relations',
            label: 'integrations.general.import_relations_label',
            type: 'switch',
        },
        {
            name: 'import_products',
            label: 'integrations.general.import_products_label',
            type: 'switch',
        },
        {
            name: 'export_job_to_invoice',
            label: 'integrations.general.export_job_to_invoice_label',
            type: 'switch',
        },
        {
            type: 'header',
            header: "integrations.general.integration_settings_label",
            dependentOn: { fieldName: 'export_job_to_invoice', value: true }
        },
        {
            type: 'text',
            name: 'invoice_template_name',
            label: 'integrations.general.eboekhouden.invoice_template_label',
            placeholder: 'integrations.general.eboekhouden.invoice_template_placeholder',
            tooltipText: 'integrations.general.eboekhouden.invoice_template_tooltip',
            dependentOn: { fieldName: 'export_job_to_invoice', value: true }
        },
        {
            type: 'text',
            name: 'default_ledger_code',
            label: 'integrations.general.eboekhouden.default_ledger_code_label',
            placeholder: 'integrations.general.eboekhouden.default_ledger_code_placeholder',
            tooltipText: 'integrations.general.eboekhouden.default_ledger_code_tooltip',
            dependentOn: { fieldName: 'export_job_to_invoice', value: true }
        },
        {
            type: 'text',
            name: 'default_payment_term',
            label: 'integrations.general.eboekhouden.default_payment_term_label',
            placeholder: 'integrations.general.eboekhouden.default_payment_term_placeholder',
            tooltipText: 'integrations.general.eboekhouden.default_payment_term_tooltip',
            dependentOn: { fieldName: 'export_job_to_invoice', value: true }
        },
        {
            type: 'header',
            showOnEdit: true,
        },
        {
            name: 'is_active',
            label: 'integrations.general.is_active_label',
            type: 'checkbox',
            showOnEdit: true,
            tooltipText: 'integrations.general.is_active_tooltipText',
        },
    ];
    
    return (
        <FormModal
            viewKey={viewKey}
            apiObject={apiObject}
            fields={fields}
            primaryButtonLabel='integrations.general.connect_button_label'
        />
    );
};

export default EBoekhoudenIntegrationForm;